import React from 'react'
import styled from 'styled-components'
import media from '../styles/media'
import colors from '../styles/colors'


const MultiColumn = ({ content }) => {
  const allColumns = content.columns.map((column, index) =>
    <Column key={`column-${index}`}>
      {column?.icon?.sourceUrl && <StyledImg alt='image' src={column?.icon?.sourceUrl} />}
      {column.headline && <ColumnHeader>{column.headline}</ColumnHeader>}
      {column.bodyCopy && <ColumnBody dangerouslySetInnerHTML={{ __html: column.bodyCopy }} />}
      {column.ctaLink && column.ctaText ? (
        <A href={column.ctaLink} target="_blank" rel='noopener noreferrer' >{column.ctaText}</A>
      ) : (null)}
    </Column>
  )

  return (
    <Container>
      <IntroContainer>
        <Header>{content.headline}</Header>
        <IntroBody dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
      </IntroContainer>
      <Rows>
        {allColumns}
      </Rows>
    </Container>
  )
}

const Container = styled.div`
  width: 76.389vw;

  ${media.fullWidth}{
    width: 1100px;
  }
  ${media.tablet} {
    margin: 0 3.906vw;
    width: 90vw;
  }
  ${media.mobile}{
    width: 90vw;
  }
`
const A = styled.a`
  color: ${colors.primaryOrange};

  ${media.hover}{
    :hover{
      text-decoration: underline;
    }
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.694vw;

  ${media.fullWidth} {
    gap: 10px;
  }

  ${media.tablet} {
    gap: 0.977vw;
  }

  ${media.mobile} {
    gap: 2.667vw;
  }
`
const ColumnBody = styled.div`
  text-align: left;
  width: 19.097vw;

  p {
    font-family: 'Archivo', sans-serif;
    font-size: 1.111vw;
    line-height: 1.389vw;

    ${media.fullWidth} {
      font-size: 16px;
      line-height: 20px;
    }
    ${media.tablet} {
      font-size: 1.563vw;
      line-height: 1.953vw;
    }
    ${media.mobile} {
      font-size: 3.738vw;
      line-height: 4.673vw;
    }
  }

${media.fullWidth} {
  width: 275px;
  }

${media.tablet}{
  width: 17.09vw;
}
${media.mobile}{
  width: 90vw;
}
`
const ColumnHeader = styled.h5`
  text-align: left;
  color: ${colors.grey800};
  font-weight: 700;
  font-size: 1.25vw;
  line-height: 1.389vw;
  width: 19.097vw;
  margin-bottom: 0.694vw;

  ${media.fullWidth} {
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 20px;
    width: 275px;
  }
  ${media.tablet} {
    font-size: 2.663vw;
    line-height: 1.989vw;
    margin-bottom: 1.563vw;
  }
  ${media.mobile} {
    text-align: left;
    width: 80vw;
    font-size: 4.733vw;
    line-height: 5.389vw;
    margin-bottom: 2.667vw;
  }
`
const StyledImg = styled.img`
  width: 10.417vw;
  
  ${media.fullWidth} {
    width: 150px;
  }

  ${media.tablet} {
    width: 14.648vw;
  }

  ${media.mobile} {
    width: 40vw;
  }
`
const Header = styled.h2`
  font-size: 2.361vw;
  font-weight: 700;
  color: ${colors.grey800};
  margin: 2.778vw 0vw 2.083vw 0vw;

  ${media.fullWidth}{
    font-size: 40px;
    margin: 40px 0px 30px 0px;
  }

  ${media.tablet} {
    font-size: 3.734vw;
    font-weight: 700;
    margin: 3.906vw 0vw 2.93vw 0vw;
  }

  ${media.mobile} {
    font-size: 9vw;
    font-weight: 700;
    margin: 10.667vw 0vw 8vw 0vw;
  }
`
const IntroBody = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.25vw;
  line-height: 1.667vw;
  gap: 1.389vw;
  font-family: 'Archivo';

  ${media.fullWidth} {
    font-size: 18px;
    line-height: 24px;
    gap: 20px;
  }
  
  ${media.tablet} {
    font-size: 1.758vw;
    line-height: 2.344vw;
    gap: 1.953vw;
  }
  
  ${media.mobile} {
    font-size: 4.206vw;
    line-height: 5.607vw;
    gap: 4.673vw;
  }

  h2 {
    ${media.desktop} {
      font-size: 3.333vw;
    }

    ${media.fullWidth} {
      font-size: 48px;
    }
    
    ${media.tablet} {
      font-size: 4.688vw;
    }
    
    ${media.mobile} {
      font-size: 11.215vw;
    }
  }

  h4 {
    font-weight: 700;

    ${media.desktop} {
      font-size: 1.361vw;
    }

    ${media.fullWidth} {
      font-size: 20px;
    }
    
    ${media.tablet} {
      font-size: 1.953vw;
    }
    
    ${media.mobile} {
      font-size: 4.673vw;
    }
  }
`
const IntroContainer = styled.div`
  text-align: center;
`
const Rows = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;
  justify-content: center;
  margin: 4.167vw 0 1.389vw 0;
  gap: 2.083vw;

  ${media.fullWidth} {
    margin: 60px 0 20px 0;
    gap: 30px;
  }

  ${media.tablet}{
    margin: 5.859vw 0 1.953vw 0;
    gap: 2.93vw;
  }

  ${media.mobile} {
    height: auto;
    flex-direction: column;
    gap: 7.009vw;
    margin: 14.019vw 0 4.673vw 0;
  }
`
export default MultiColumn
